import { CMSSection } from "@/cms/models";
import {
  getDesktopHeight,
  getMargins,
  getMobileHeight,
  getPaddings,
} from "@/utils/theme-helper";
import React from "react";

const SectionLayout: React.FC<{
  children: React.ReactNode;
  cmsSection: CMSSection<any>;
}> = ({ children, cmsSection }) => {
  const getSizeClassName = () => {
    switch (cmsSection.ui?.width) {
      case "sm":
        return "max-w-screen-sm";
      case "md":
        return "max-w-screen-md";
      case "lg":
        return "max-w-screen-lg";
      case "xl":
        return "max-w-screen-xl";
      case "2xl":
        return "max-w-screen-2xl";
      case "4xl":
        return "max-w-screen-4xl";
      case "full":
        return "w-full";
      default:
        return "max-w-screen-xl";
    }
  };

  const bgImage = cmsSection.specifics?.bgImage ?? cmsSection.ui?.bgImage ?? "";

  return (
    <section
      data-section-type={cmsSection?.type}
      className={`flex flex-1 ${cmsSection.id} ${getMargins(cmsSection.ui.margin)}`}
      style={{
        backgroundImage: bgImage ? `url('${bgImage}')` : "none",
        backgroundSize: cmsSection.ui.bgSize ?? "cover",
        backgroundRepeat: "no-repeat",
        backgroundPositionX: cmsSection.ui.backgroundPositionX ?? "center",
        backgroundPositionY: cmsSection.ui.backgroundPositionY ?? "center",
      }}
    >
      <style>
        {` ${`.${cmsSection.id}`} {
        --section-text-color: ${cmsSection.specifics?.textColor ?? cmsSection.ui?.textColor ?? cmsSection.specifics?.farvetekst ?? "inherit"};
        --section-bg-color: ${cmsSection.specifics?.bgColor ?? cmsSection.ui?.bgColor ?? cmsSection.specifics?.farvebaggrund ?? "transparent"};
        --section-desktop-height: ${getDesktopHeight(cmsSection.ui?.height)};
        --section-mobile-height: ${getMobileHeight(cmsSection.ui?.height)};
        }`}
      </style>
      <div
        className={`flex flex-1 justify-center h-[var(--section-mobile-height)] md:h-[var(--section-desktop-height)] bg-[var(--section-bg-color)] w-full text-[var(--section-text-color)] relative`}
      >
        <div
          className={`${getSizeClassName()} w-full flex-1 ${getPaddings(cmsSection.ui?.padding)}`}
        >
          {children}
        </div>
      </div>
    </section>
  );
};

export default SectionLayout;
